// @flow

import * as React from 'react';
import { debounce } from 'debounce';

import Form from './Form';
import Input from './Input';

const Filter = (props) => {
  const { changeBookingsFilter } = props;

  const delayedChangeFilterCriteria = debounce(changeBookingsFilter, 300);

  const onChange = (event) => {
    event.persist();
    delayedChangeFilterCriteria(event.target.value.toLowerCase());
  };

  return (
    <Form>
      <Input
        type='text'
        onChange={onChange}
        defaultValue={window.GEODISC_DEBUG_DEFAULT_BOOKINGS_PANEL_FILTER || ''}
        placeholder='Filter bookings'
      />
    </Form>
  );
};

export default React.memo(Filter);
